















































































































































































































































































































import { Component, PropSync, Vue, Watch } from "vue-property-decorator";
import {
  FinDocViewModel,
  TaxRecapCalculationResultModel,
} from "./models";
import LoadingOverlay from "@/components/misc/LoadingOverlay.vue";
import { Getter } from "vuex-class";
import { FinancialSettingsType } from "@/store/modules/financial";
import { getPriceSummary } from "./functions";
import {
  FinancialDocumentStatusEnum,
  FinancialDocumentTypesEnum,
} from "@/shared/models/enums.type";

@Component({
  components: {
    LoadingOverlay,
  },
})
export default class TaxRecap extends Vue {
  @PropSync("finDocModel") finDocModelInternal!: FinDocViewModel;
  @PropSync("hasError", { default: false }) hasErrorInternal?: boolean;
  @PropSync("automaticallyCancelRelatedAdvanceInvoices")
  automaticallyCancelRelatedAdvanceInvoicesInternal?: boolean;

  isOpen = false;
  loading = false;

  taxRecap: TaxRecapCalculationResultModel | null = null;

  @Watch("isOpen")
  openWatch(fresh: boolean) {
    if (fresh) {
      // load on open
      this.calculateTaxRecap();
    } else {
      // reset on close
      this.loading = false;
      this.taxRecap = null;
    }
  }

  calculateTaxRecap() {
    this.loading = true;
    Vue.axios
      .post<TaxRecapCalculationResultModel>(
        "financialDocuments/CalculateTaxRecap",
        {
          documentTypeId: this.finDocModelInternal.documentTypeId,
          lineItems: this.finDocModelInternal.lineItems,
          relatedAdvanceInvoices: this
            .automaticallyCancelRelatedAdvanceInvoicesInternal
            ? []
            : this.finDocModelInternal.relatedAdvanceInvoices,
        }
      )
      .then((res) => {
        this.taxRecap = res.data;
        this.hasErrorInternal = this.taxRecap.hasError;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  @Watch("hasErrorInternal")
  errorWatch(fresh: boolean, old: boolean) {
    if (fresh && !old && !this.isOpen) {
      this.isOpen = true;
    }
  }

  get totalToPay() {
    const summary = getPriceSummary(this.finDocModelInternal);
    return this.automaticallyCancelRelatedAdvanceInvoicesInternal
      ? summary.toPayWithoutAdvance
      : summary.toPay;
  }

  get isInvalid() {
    return this.taxRecap?.hasError ?? false;
  }

  get hasRelatedAdvanceInvoices() {
    return (
      this.finDocModelInternal.relatedAdvanceInvoices &&
      this.finDocModelInternal.relatedAdvanceInvoices.length > 0
    );
  }

  removeRelatedAdvanceInvoices() {
    const toRemove = this.finDocModelInternal.relatedAdvanceInvoices;
    this.finDocModelInternal.relatedAdvanceInvoices = [];
    this.finDocModelInternal.unassignedAdvanceInvoices.push(...toRemove);

    this.calculateTaxRecap();
  }

  get canAutomaticallyCancelRelatedAdvanceInvoices() {
    return (
      this.finDocModelInternal.relatedAdvanceInvoices &&
      this.finDocModelInternal.relatedAdvanceInvoices.length > 0 &&
      this.finDocModelInternal.documentTypeId ===
      FinancialDocumentTypesEnum.Racun &&
      this.finDocModelInternal.documentStatusId ===
      FinancialDocumentStatusEnum.UIzradi
    );
  }

  toggleAutomaticCancellationOfRelatedAdvanceInvoices() {
    this.automaticallyCancelRelatedAdvanceInvoicesInternal =
      !this.automaticallyCancelRelatedAdvanceInvoicesInternal;

    this.$nextTick(() => {
      this.calculateTaxRecap();
    });
  }

  @Getter("financial/settings") storedSettings?: FinancialSettingsType;

  get workingCurrencyCode() {
    return this.storedSettings?.workingCurrency.isoCode ?? "EUR";
  }
}
